module.exports = __webpack_public_path__ + "img/home-delivery_medium.5d4f7bfa.jpg";